const numberFormatter = require('../../../../bin/helpers/numberFormatter');

export default numberFormatter;
